import { UtilS } from '@modules/Util/S/Function/module/UtilS';
import { generateUniqueIds } from '@modules/Vector/S/Function/composite/svg.material-composer.helper.ts';
import {
  attachLoop,
  buildReliefFilter,
} from '@modules/Vector/S/Function/composite/svg.relief-composer.helper.ts';
import {
  createClippedGroup,
  createCutAndClipPaths,
  ensureDefsElement,
  findCutPath,
  parseViewBox,
} from '@modules/Vector/S/Function/composite/svg.utils.ts';
import { ReliefOptions } from '@modules/Vector/S/Function/composite/svg.composite.types.ts';
import { RELIEF_OPTIONS } from '@modules/Vector/S/Constant/doll.constant.ts';

/**
 * 📦 스티커 양감(emboss/bevel/specular) 합성
 * - 실패 시 원본 그대로 반환 (graceful)
 * - 원본 도형 색을 다시 칠하지 않고, “효과 레이어만” 위로 얹는다.
 */
export class SvgReliefComposer {
  static async composeWithRelief(svgString: string, options?: ReliefOptions): Promise<string> {
    if (UtilS.isEmpty(svgString)) return svgString;

    try {
      // SVG 문서 파싱
      const doc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
      const svg = doc.documentElement as unknown as SVGSVGElement;

      // 1) 컷라인 찾기
      const cutPath = findCutPath(svg);
      if (!cutPath) return svgString;

      // 2) defs 확보
      const defs = ensureDefsElement(svg, doc);

      const ids = generateUniqueIds();
      ids.filter = `${options?.idPrefix ?? ''}relief-${Math.random().toString(36).slice(2, 9)}`;

      // 2) 컷/클립 생성 (ids를 넘김)
      createCutAndClipPaths(doc, cutPath, ids, defs);

      // 3) viewBox 파싱 (필터 bbox 위해)
      const vb = parseViewBox(svg);

      // 4) relief 필터를 ids.filter 로 생성
      buildReliefFilter(doc, defs, options, ids.filter, vb);

      // 5) 클립 그룹 만들기
      createClippedGroup(doc, svg, ids, { source: 'material' });

      await attachLoop({
        svg,
        target: svgString,
        ...RELIEF_OPTIONS.LOOP_CONFIG,
      });
      return new XMLSerializer().serializeToString(doc);
    } catch (err) {
      console.error('SvgReliefComposer failed:', err);
      return svgString;
    }
  }
}
